export default [
  {
    title: 'مدیریت تیکت ها',
    icon: 'bx bx-support',
    children: [
      {
        title: 'تیکت ها',
        route: { name: 'ticketList' },
        resource: 'TicketManager',
        action: 'show',
      },
      {
        title: 'دپارتمان ها',
        route: { name: 'ticketdepartment' },
        resource: 'TicketDepartmentManager',
        action: 'show',
      },
    ],
  },
]
